const MainNav = (() => {

	const DOM = {};

	const cacheDOM    = () => {
		DOM.hamburger = document.getElementById( 'hamburger' );
		DOM.nav       = document.getElementById( 'nav-container' );
		DOM.html      = document.getElementsByTagName( 'html' );
		DOM.size      = DOM.html[0].getBoundingClientRect().width;
		DOM.item      = document.querySelectorAll( '.menu-item' );
		DOM.sub       = document.querySelectorAll( '.sub-menu' );
		DOM.inner     = document.querySelectorAll( '.inner-menu' );
		DOM.icon      = document.querySelectorAll( '.dropdown-icon' );
	};

	const onLoad = () => {
		if (DOM.size < 992) {
			DOM.nav.style.height = '0px';
		}
	};

	const eventListener = () => {
		DOM.hamburger.addEventListener( 'click', toggleMenu );
		if (DOM.size < 992) {
			DOM.item.forEach(
				function (item){
					item.addEventListener(
						'click',
						function (e) {
							if (item.classList.contains( 'inner-menu' )) {
								if ( ! item.classList.contains( 'active' )) {
									e.preventDefault();
								}
								item.lastElementChild.setAttribute( 'style', 'height: 100%;' )
								item.classList.add( 'active' );
								DOM.nav.style.height = DOM.nav.scrollHeight + 'px';
								e.stopPropagation();
							} else if(item.classList.contains( 'has-sub' )) {
								if (item.classList.contains( 'active' )) {

								} else {
									e.preventDefault();
									item.lastElementChild.setAttribute( 'style', 'height: 100%;' )
									item.classList.add( 'active' );
									DOM.nav.style.height = DOM.nav.scrollHeight + 'px';
								}
							}
						}
					);
				}
			);
			DOM.icon.forEach(
				function (icon) {
					icon.addEventListener(
						'click',
						function (e) {
							const container = icon.parentElement.parentElement;
							if(container.classList.contains('active')) {
								container.lastElementChild.setAttribute( 'style', 'height: 0;' )
								container.classList.remove('active');
								DOM.nav.style.height = DOM.nav.scrollHeight + 'px';
							}
						}
					);
				}
			);
		}
	};

	const toggleMenu = () => {
		if (DOM.nav.classList.contains( 'active' )) {
			DOM.nav.classList.remove( 'active' );
			DOM.nav.style.height = '0px';
		} else {
			DOM.nav.classList.add( 'active' );
			DOM.nav.style.height = DOM.nav.scrollHeight + 'px';
		}
	};

	const init = () => {
		cacheDOM();
		onLoad();
		eventListener();
	};

	return {
		init,
	};
})();

export default MainNav;
